import instanceAuth from '@network/auth';

export interface ITierMilestone {
  id: number;
  tierId: number;
  milestoneId: number;
  order: number;
  createdAt: string;
  updatedAt: string;
  milestone: {
    id: number;
    title: string;
    status: string;
    numberOfQuestions: number;
    userId: number;
    merchantId: number;
    createdAt: string;
    updatedAt: string;
    deletedAt?: string | null;
  };
}

export interface ITier {
  id: number;
  name: string;
  description?: string;
  merchantId: number;
  merchant?: {
    id: number;
    name: string;
    type: string;
  };
  order: number;
  status: string;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string | null;
  tierMilestones: ITierMilestone[];
}

export interface ITierResponse {
  tiers: ITier[];
  total: number;
}

export async function getAllTiers(): Promise<ITierResponse> {
  const instance = instanceAuth();
  const res = await instance.get("/users/tiers");
  
  // Extract data from the nested response structure
  return {
    tiers: res.data.data?.tiers || [],
    total: res.data.data?.total || 0,
  };
}
